import * as React from 'react';
import Button from '../../../common/form/Button';
import {userIsCompanyManageUser,userIsPropertyManageUser,userIsSystemManageUser} from '../../../../utilities/identity';

interface Props {
    description: string;
    layout: string;
    pmsUnitId: string;
    beingEdited: boolean;
    onToggleEdit: () => void;
    onDelete: () => void;
    onSubmit: () => void;
    onDescriptionChanged: (description: string) => void;
    pmsUnitIdChange: (pmsUnitId: string) => void;
    onLayoutChanged: (layout: string) => void;
}

const UnitTypeRow = (props: Props) => {
    const handleDescriptionChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
        props.onDescriptionChanged(e.currentTarget.value);
    };
    const handleLayoutChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
        props.onLayoutChanged(e.currentTarget.value);
    };
    const handlePmsUnitIdChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
        props.pmsUnitIdChange(e.currentTarget.value);
    };
    const isUser = (
        userIsCompanyManageUser() ||
        userIsPropertyManageUser() ||
        userIsSystemManageUser()
    );

    return (
        <tr>
            <td className="unit-type-big-col">
                {props.beingEdited ? (
                    <>
                        <small className="form-text text-muted">
                            Description (Prospects will see this)
                        </small>
                        <input
                            type="text"
                            className="form-control"
                            onChange={handleDescriptionChange}
                            value={props.description}
                        />
                    </>
                ) : (
                    <>
                        <small className="form-text text-muted">Description</small>
                        <div>{props.description}</div>
                    </>
                )}
            </td>
            <td className="unit-type-big-col">
            {props.beingEdited ? (
                    <>
                        <small className="form-text text-muted">
                           PMS UnitId
                        </small>
                        <input
                            type="text"
                            className="form-control"
                            onChange={handlePmsUnitIdChange}
                            value={props.pmsUnitId}
                        />
                    </>
                ) : (
                    <>
                        <small className="form-text text-muted">PMS UnitId</small>
                        <div>{props.pmsUnitId}</div>
                    </>
                )}
            </td>
            <td className="unit-type-big-col">
                {props.beingEdited ? (
                    <>
                        <small className="form-text text-muted">
                            Value
                        </small>
                        <input
                            type="text"
                            className="form-control"
                            style={{ width: '100px' }}
                            onChange={handleLayoutChange}
                            value={props.layout}
                        />
                    </>
                ) : (
                    <>
                        <small className="form-text text-muted">Layout</small>
                        <div>{props.layout}</div>
                    </>
                )}
            </td>
            <td>
                {props.beingEdited ? (
                    <Button text="Update" addlClassName="btn-primary" onClick={props.onSubmit} disabled={isUser}/>
                ) : (
                    <Button text="Edit" addlClassName="btn-primary" onClick={props.onToggleEdit} disabled={isUser}/>
                )}
            </td>
            <td>
                {props.beingEdited ? (
                    <Button
                        text="Cancel"
                        addlClassName="btn-secondary"
                        onClick={props.onToggleEdit}
                    />
                ) : (
                    <Button text="Delete" addlClassName="btn-danger" onClick={props.onDelete} disabled={isUser}/>
                )}
            </td>
        </tr>
    );
};

export default UnitTypeRow;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/UnitTypeRow.tsx